import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useEffect, useState } from "react";
import tutri from "../../asset/tuturi2.webp";
import KertasA4 from "./KertasA4";

/* ================= FOOTER ================= */
const Footer = ({ siswa, page }) => (
  <footer className="border-t border-black pt-1 mt-8 text-[10px] font-serif">
    <div className="flex justify-between italic tracking-wider">
      <div className="flex gap-2">
        <span>
          KELAS <span className="font-arial">{siswa.kelas}</span>
          {siswa.rombel}
        </span>
        <span>|</span>
        <span className="uppercase">{siswa.name}</span>
        <span>|</span>
        <span className="uppercase font-sans">{siswa.NIPD}</span>
      </div>
      <div className="flex gap-5">
        <span>Halaman </span>
        <span className="font-sans">: {page}</span>
      </div>
    </div>
  </footer>
);

const BioRow = ({ no, label, value, sub = false }) => (
  <div className="flex leading-relaxed">
    {/* Kolom nomor */}
    <div className="w-8">{!sub && no ? `${no}.` : ""}</div>

    {/* Kolom label */}
    <div className={`w-52 ${sub ? "" : ""}`}>
      {sub && no ? `${no}. ` : ""}
      {label}
    </div>

    <div className="w-4">:</div>
    <div className="flex-1">{value || "-"}</div>
  </div>
);

/* ================= MAIN ================= */
const CoverRapor = () => {
  const [siswas, setSiswas] = useState([]);
  const [siswaAktif, setSiswaAktif] = useState(null);
  const [kepsek, setKepsek] = useState(null);
  const [kelas, setKelas] = useState("");
  const [nama, setNama] = useState("");
  const [nisn, setNisn] = useState("");

  const [dataSekolah, setDataSekolah] = useState(null);

  /* ========== FETCH SISWA ========== */
  useEffect(() => {
    const fetchSiswas = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}api/auth/users`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setSiswas(res.data.filter((u) => u.role === "siswa"));
      } catch (err) {
        console.error("Gagal mengambil data siswa", err);
      }
    };
    fetchSiswas();
  }, []);

  useEffect(() => {
    const fetchKepsek = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}api/auth/users`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const kepsek = res.data.find(
          (u) =>
            u.role === "guru" && u.jabatan?.toLowerCase() === "kepala sekolah"
        );

        setKepsek(kepsek);
      } catch (err) {
        console.error("Gagal mengambil data kepala sekolah", err);
      }
    };

    fetchKepsek();
  }, []);

  const downloadPDF = async () => {
    const pageIds = ["page-1", "page-2", "page-3", "page-4"];
    const pdf = new jsPDF("p", "mm", "a4");

    for (let i = 0; i < pageIds.length; i++) {
      const page = document.getElementById(pageIds[i]);
      if (!page) continue;

      const canvas = await html2canvas(page, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
        windowWidth: page.scrollWidth,
        windowHeight: page.scrollHeight,
      });

      const imgData = canvas.toDataURL("image/png");

      if (i > 0) pdf.addPage();

      // ⬅️ PAKSA FULL A4
      pdf.addImage(imgData, "PNG", 0, 0, 210, 297);
    }

    pdf.save(`Rapor_${siswaAktif.name}.pdf`);
  };

  /* ========== FETCH DATA SEKOLAH ========== */
  useEffect(() => {
    const fetchDataSekolah = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}api/datasekolah/all`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setDataSekolah(res.data[0]); // ambil 1 data sekolah
      } catch (err) {
        console.error("Gagal mengambil data sekolah", err);
      }
    };
    fetchDataSekolah();
  }, []);

  /* ========== FILTER ========== */
  const filteredSiswas = siswas.filter(
    (s) =>
      (kelas === "" || s.kelas === kelas) &&
      (nama === "" || s.name?.toLowerCase().includes(nama.toLowerCase())) &&
      (nisn === "" || s.NISN?.includes(nisn))
  );

  let page = 1;
  const Identitas = ({ label, value }) => (
    <div className="flex">
      <div className="w-36">{label}</div>
      <div className="w-4">:</div>
      <div className="flex-1">{value || "-"}</div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-100 p-6 space-y-6">
      {/* ================= FILTER ================= */}
      <div className="bg-white p-4 rounded shadow no-print">
        <h2 className="font-bold mb-4">Filter Data Siswa</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <input
            placeholder="Cari Nama"
            value={nama}
            onChange={(e) => setNama(e.target.value)}
            className="border p-2 rounded"
          />
          <input
            placeholder="Cari NISN"
            value={nisn}
            onChange={(e) => setNisn(e.target.value)}
            className="border p-2 rounded"
          />
          <select
            value={kelas}
            onChange={(e) => setKelas(e.target.value)}
            className="border p-2 rounded"
          >
            <option value="">Pilih Kelas</option>
            {[1, 2, 3, 4, 5, 6].map((k) => (
              <option key={k} value={String(k)}>
                Kelas {k}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* ================= LIST SISWA ================= */}
      <div className="bg-white p-4 rounded shadow max-h-64 overflow-y-auto no-print">
        <h2 className="font-semibold mb-2">Daftar Siswa</h2>
        <ul className="divide-y">
          {filteredSiswas.map((s) => (
            <li
              key={s._id}
              onClick={() => setSiswaAktif(s)}
              className={`py-2 px-2 cursor-pointer rounded ${
                siswaAktif?._id === s._id
                  ? "bg-blue-200 font-semibold"
                  : "hover:bg-blue-50"
              }`}
            >
              {s.name} — Kelas {s.kelas} {s.rombel}
              <div className="text-sm text-gray-500">NISN: {s.NISN}</div>
            </li>
          ))}
        </ul>
      </div>

      {/* ================= KERTAS A4 ================= */}
      <div className="p-6 font-arial grid justify-center gap-y-20">
        {siswaAktif ? (
          <>
            {/* ========== HALAMAN 1 : COVER ========== */}
            <div
              id="page-1"
              className="print-page"
              style={{
                width: "210mm",
                height: "297mm",
                background: "white",
              }}
            >
              <KertasA4>
                <div className="h-[850px]">
                  <div className="flex justify-center mt-20">
                    <img src={tutri} alt="Tut Wuri" className="w-64 h-40" />
                  </div>

                  <div className="text-center mt-10 text-2xl font-bold space-y-1">
                    <h1>RAPOR</h1>
                    <h1>SEKOLAH DASAR</h1>
                    <h1>( SD )</h1>
                  </div>

                  <div className="text-center mt-32 space-y-2">
                    <div>
                      <p className="font-bold pb-2">Nama Peserta Didik</p>
                      <div className="border border-black mx-24 pb-4 font-semibold">
                        {siswaAktif.name}
                      </div>
                    </div>

                    <div>
                      <p className="font-bold pb-2">NISN / NIS</p>
                      <div className="border border-black mx-28 pb-4 font-semibold">
                        {siswaAktif.NISN} / {siswaAktif.NIPD}
                      </div>
                    </div>
                  </div>

                  <div className="text-center font-bold text-lg mt-32">
                    <p>
                      KEMENTERIAN PENDIDIKAN, KEBUDAYAAN, RISET, DAN TEKNOLOGI
                    </p>

                    <p>REPUBLIK INDONESIA</p>
                  </div>
                </div>
                <Footer siswa={siswaAktif} page={page++} />
              </KertasA4>
            </div>
            {/* ========== HALAMAN 2 : IDENTITAS SEKOLAH ========== */}
            <div
              id="page-2"
              className="print-page"
              style={{
                width: "210mm",
                height: "297mm",
                background: "white",
              }}
            >
              {dataSekolah && (
                <KertasA4>
                  <div className="h-[935px] px-12  font-arial text-[14px]">
                    {/* JUDUL */}
                    <div className="text-center mb-16 leading-snug text-[16px]">
                      <p className="font-bold uppercase">RAPOR</p>
                      <p className="font-bold uppercase">SEKOLAH DASAR</p>
                      <p className="font-bold">( SD )</p>
                    </div>

                    {/* ISI IDENTITAS */}
                    <div className="space-y-4">
                      <Identitas
                        label="Nama Sekolah"
                        value={dataSekolah.namasekolah}
                      />
                      <Identitas label="NPSN" value={dataSekolah.NPSN} />
                      <Identitas
                        label="NIS/NSS/NDS"
                        value={dataSekolah.NISNSSNDS}
                      />

                      <Identitas
                        label="Alamat Sekolah"
                        value={
                          <>
                            {dataSekolah.alamat}
                            <br />
                            Kode Pos : {dataSekolah.kodePos}, Telp.{" "}
                            {dataSekolah.telpon}
                          </>
                        }
                      />

                      <Identitas
                        label="Kelurahan / Desa"
                        value={dataSekolah.ttDsekolah}
                      />
                      <Identitas
                        label="Kecamatan"
                        value={`${dataSekolah.Kec}`}
                      />
                      <Identitas
                        label="Kota / Kabupaten"
                        value={`Kab. ${dataSekolah.kab}`}
                      />
                      <Identitas
                        label="Provinsi"
                        value={`Prov. ${dataSekolah.prov}`}
                      />
                      <Identitas label="Website" value={dataSekolah.website} />
                      <Identitas label="E-mail" value={dataSekolah.email} />
                    </div>
                  </div>

                  <Footer siswa={siswaAktif} page={page++} />
                </KertasA4>
              )}
            </div>
            <div
              id="page-3"
              className="print-page"
              style={{
                width: "210mm",
                height: "297mm",
                background: "white",
              }}
            >
              {dataSekolah && (
                <KertasA4>
                  <div className="h-[940px] px-8  font-sans text-[14px]">
                    {/* JUDUL */}
                    <h1 className="text-center font-bold uppercase mb-5 text-[16px]">
                      Keterangan Diri Peserta Didik
                    </h1>

                    {/* BIODATA */}
                    <div className="space-y-0.5">
                      <BioRow
                        no="1"
                        label="Nama Peserta Didik (Lengkap)"
                        value={siswaAktif.name?.toUpperCase()}
                      />
                      <BioRow
                        no="2"
                        label="Nomor Induk / NISN"
                        value={`${siswaAktif.NIPD || "-"} / ${
                          siswaAktif.NISN || "-"
                        }`}
                      />
                      <BioRow
                        no="3"
                        label="Tempat, Tanggal Lahir"
                        value={`${siswaAktif.TL || "-"}, ${
                          siswaAktif.TGL
                            ? new Date(siswaAktif.TGL).toLocaleDateString(
                                "id-ID",
                                {
                                  day: "2-digit",
                                  month: "long",
                                  year: "numeric",
                                }
                              )
                            : "-"
                        }`}
                      />
                      <BioRow
                        no="4"
                        label="Jenis Kelamin"
                        value={siswaAktif.kelamin}
                      />
                      <BioRow no="5" label="Agama" value={siswaAktif.Agama} />
                      <BioRow
                        no="6"
                        label="Status dalam Keluarga"
                        value={siswaAktif.statusKeluarga}
                      />
                      <BioRow
                        no="7"
                        label="Anak ke"
                        value={siswaAktif.anakke}
                      />
                      <BioRow
                        no="8"
                        label="Alamat Peserta Didik"
                        value={siswaAktif.Alamat}
                      />
                      <BioRow
                        no="9"
                        label="Nomor Telepon Rumah"
                        value={siswaAktif.telepon}
                      />
                      <BioRow
                        no="10"
                        label="Sekolah Asal"
                        value={siswaAktif.SekolahAsal}
                      />
                      <BioRow
                        no="11"
                        label="Diterima di sekolah ini"
                        value={dataSekolah.namasekolah}
                      />
                      <BioRow
                        label="Di Kelas"
                        value={`Kelas ${siswaAktif.kelas} ${siswaAktif.rombel}`}
                      />
                      <BioRow
                        no="3"
                        label="Pada Tanggal"
                        value={`${
                          siswaAktif.TGLditerima
                            ? new Date(
                                siswaAktif.TGLditerima
                              ).toLocaleDateString("id-ID", {
                                day: "2-digit",
                                month: "long",
                                year: "numeric",
                              })
                            : "-"
                        }`}
                      />

                      <BioRow no="12" label="Nama Orang Tua" />
                      <BioRow no="a" label="Ayah" value={siswaAktif.ayah} sub />
                      <BioRow no="b" label="Ibu" value={siswaAktif.ibu} sub />

                      <BioRow
                        no="13"
                        label="Alamat Orang Tua"
                        value={siswaAktif.alamatOrtu}
                      />
                      <BioRow
                        label="Nomor Telpon Rumah"
                        value={siswaAktif.noTLP}
                      />
                      <BioRow no="14" label="Pekerjaan Orang Tua" />
                      <BioRow
                        no="a"
                        label="Ayah"
                        value={siswaAktif.Payah}
                        sub
                      />
                      <BioRow no="b" label="Ibu" value={siswaAktif.Pibu} sub />

                      <BioRow
                        no="15"
                        label="Nama Wali Siswa"
                        value={siswaAktif.wali}
                      />
                      <BioRow
                        no="16"
                        label="Alamat Wali Peserta Didik"
                        value={siswaAktif.alamatWali}
                      />
                      <BioRow
                        label="Nomor Telpon Wali"
                        value={siswaAktif.noTLPWali}
                        sub
                      />
                      <BioRow
                        no="17"
                        label="Pekerjaan Wali Peserta Didik"
                        value={siswaAktif.Pwali}
                      />
                    </div>

                    {/* BAGIAN BAWAH */}
                    <div className="flex justify-between items-end mt-8 gap-x-24">
                      {/* FOTO */}

                      <div className="w-1/2 flex justify-end">
                        <div className="w-[113px] h-[151px] border border-black overflow-hidden flex items-center justify-center text-xs">
                          {siswaAktif?.image?.filename ? (
                            <img
                              src={`${process.env.REACT_APP_API_URL}api/auth/users/image/${siswaAktif.image.filename}`}
                              alt="Foto Kepala Sekolah"
                              className="w-full h-full object-cover"
                            />
                          ) : (
                            "Foto 3x4"
                          )}
                        </div>
                      </div>
                      {/* TTD */}
                      <div className="grid  justify-start text-start w-1/2 text-sm">
                        <p>Dasan Lekong, 10 Juli 2023</p>
                        <div className="grid justify-start text-start">
                          <p className="flex">Kepala Sekolah,</p>
                          <div className="h-[105px]"></div>
                          <p className="font-bold text-[12px] inline-block absolute border-b border-black min-w-[180px] mt-[105px] pb-1">
                            <span>{kepsek?.name || "\u00A0"}</span>
                          </p>
                          <p>NIP.{kepsek ? kepsek.NIP : "-"}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Footer siswa={siswaAktif} page={page++} />
                </KertasA4>
              )}
            </div>
            <div
              id="page-4"
              className="print-page"
              style={{
                width: "210mm",
                height: "297mm",
                background: "white",
                padding: "20mm",
                fontFamily: "Times New Roman",
              }}
            >
              <div className="h-full flex flex-col justify-between">
                {/* ================= JUDUL ================= */}
                <div className="pb-40 ">
                  <p className="text-center font-bold text-[16px] mb-4">
                    KETERANGAN PINDAH SEKOLAH
                  </p>

                  <p className="text-[13px] mb-4">
                    Nama Peserta Didik :{" "}
                    <span className="font-semibold">{siswaAktif?.name}</span>
                  </p>

                  {/* ================= TABEL ================= */}
                  <table className="w-full border border-black border-collapse text-[12px] ">
                    <thead>
                      {/* HEADER BARIS 1 */}
                      <tr>
                        <th
                          colSpan={4}
                          className="border border-black px-2 pb-3 text-center font-bold"
                        >
                          KELUAR
                        </th>
                      </tr>

                      {/* HEADER BARIS 2 */}
                      <tr>
                        <th className="border border-black px-2 pb-3 w-[15%] text-center">
                          Tanggal
                        </th>
                        <th className="border border-black px-2 pb-3 w-[20%] text-center">
                          Kelas yang ditinggalkan
                        </th>
                        <th className="border border-black px-2 pb-3 w-[35%] text-center">
                          Sebab-sebab keluar / Atas permintaan
                          <br />
                          <span>(Tertulis)</span>
                        </th>
                        <th className="border border-black px-2 pb-3 w-[30%] text-center">
                          Tanda Tangan Kepala Sekolah,
                          <br />
                          Stempel Sekolah, dan Orang Tua/Wali
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {[1, 2, 3].map((row) => (
                        <tr key={row}>
                          {/* TANGGAL */}
                          <td className="border border-black p-2 align-top h-[140px] text-center">
                            &nbsp;
                          </td>

                          {/* KELAS */}
                          <td className="border border-black p-2 align-top">
                            &nbsp;
                          </td>

                          {/* SEBAB */}
                          <td className="border border-black p-2 align-top">
                            &nbsp;
                          </td>

                          {/* TTD */}
                          <td className="border border-black p-3 align-top">
                            <p>Kepala Sekolah,</p>
                            <div className="h-[35px]" />
                            <p>.................................</p>
                            <p className="text-[11px]">NIP.</p>

                            <div className="mt-5">
                              <p>Orang Tua/Wali,</p>
                              <div className="h-[35px]" />
                              <p>.................................</p>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* ================= FOOTER ================= */}
                <Footer siswa={siswaAktif} page={page++} />
              </div>
            </div>
          </>
        ) : (
          <p className="text-center text-gray-600">
            Pilih siswa untuk menampilkan rapor
          </p>
        )}
      </div>
      {siswaAktif && (
        <div className="no-print mb-4 flex justify-end">
          <button
            onClick={downloadPDF}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            Download Rapor (PDF)
          </button>
        </div>
      )}
    </div>
  );
};

export default CoverRapor;
